import { useMemo } from "react";
import { VeterinarianStore } from "../VeterinarianStore";

/**
 * Create a Veterinarian Store
 * @returns
 */
export const useCreateVeterinarianStore = () => {
    const [vetStore] = useMemo(() => [new VeterinarianStore()], []);
    return vetStore;
}
